(function () {
    if (typeof window.CustomEvent === 'function') return false; //If not IE

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

function pasteHtmlAtCaret(html) {
    var sel, range;
    if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
            range = sel.getRangeAt(0);
            range.deleteContents();

            // Range.createContextualFragment() would be useful here but is
            // only relatively recently standardized and is not supported in
            // some browsers (IE9, for one)
            var el = document.createElement('div');
            el.innerHTML = html;
            var frag = document.createDocumentFragment(),
                node,
                lastNode;
            while ((node = el.firstChild)) {
                lastNode = frag.appendChild(node);
            }
            range.insertNode(frag);

            // Preserve the selection
            if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    } else if (document.selection && document.selection.type != 'Control') {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
    }
}

function insertAtCaret(txtarea, text) {
    var scrollPos = txtarea.scrollTop;
    var strPos = 0;
    var br = txtarea.selectionStart || txtarea.selectionStart == '0' ? 'ff' : document.selection ? 'ie' : false;
    var range;
    if (br == 'ie') {
        txtarea.focus();
        range = document.selection.createRange();
        range.moveStart('character', -txtarea.value.length);
        strPos = range.text.length;
    } else if (br == 'ff') strPos = txtarea.selectionStart;

    var front = txtarea.value.substring(0, strPos);
    var back = txtarea.value.substring(strPos, txtarea.value.length);
    txtarea.value = front + text + back;
    strPos = strPos + text.length;
    if (br == 'ie') {
        txtarea.focus();
        range = document.selection.createRange();
        range.moveStart('character', -txtarea.value.length);
        range.moveStart('character', strPos);
        range.moveEnd('character', 0);
        range.select();
    } else if (br == 'ff') {
        txtarea.selectionStart = strPos;
        txtarea.selectionEnd = strPos;
        txtarea.focus();
    }
    txtarea.scrollTop = scrollPos;
}

angular
    .module('tradersyard')
    .constant('$moji.sizes', {
        '45x45': 'hdpi',
        '23x23': 'ldpi',
        '30x30': 'mdpi',
        '60x60': 'xhdpi',
        '90x90': 'xxhdpi',
        '120x120x': 'xxxhdpi',
        hdpi: 'hdpi',
        ldpi: 'ldpi',
        mdpi: 'mdpi',
        xhdpi: 'xhdpi',
        xxhdpi: 'xxhdpi',
        xxxhdpi: 'xxxhdpi',
    })
    .constant('$moji.mapping', [
        {
            description: 'Slightly Smiling Face',
            codes: ['smile'],
            snippets: [':)', ':-)'],
            default: ':)',
            fileName: 'yard-smiley-3',
        },
        {
            description: 'Smirking Face',
            codes: ['smirk'],
            snippets: [';^)'],
            default: 'smirk',
            fileName: 'yard-smiley-4',
        },
        {
            description: 'Thumb Up',
            codes: ['like'],
            snippets: [],
            default: 'like',
            fileName: 'yard-smiley-like',
        },
        {
            description: 'Face With Stuck-Out Tongue',
            codes: ['stuck_out_tongue'],
            snippets: [';p', ';-p', ':-p', ':p'],
            default: ':P',
            fileName: 'yard-smiley-1',
        },
        {
            description: 'Grinning Face With Smiling Eyes',
            codes: ['grin'],
            snippets: [';D', ';-D'],
            default: 'grin',
            fileName: 'yard-smiley-2',
        },
        {
            description: 'Sleepy Face',
            codes: ['sleepy'],
            snippets: [],
            default: 'sleepy',
            fileName: 'yard-smiley-5',
        },
        {
            description: 'Face With Tears of Joy',
            codes: ['joy'],
            snippets: [":'‑)", ":')", ";')"],
            default: ":')",
            fileName: 'yard-smiley-6',
        },
        {
            description: 'Neutral Face',
            codes: ['neutral_face'],
            snippets: [':|'],
            default: ':|',
            fileName: 'yard-smiley-7',
        },
        {
            description: 'Grinning Face',
            codes: ['grinning'],
            snippets: [';D', ';-D'],
            default: 'grinning',
            fileName: 'yard-smiley-8',
        },
        {
            description: 'Face With Open Mouth',
            codes: ['open_mouth'],
            snippets: ['%‑)', '%)'],
            default: 'open_mouth',
            fileName: 'yard-smiley-9',
        },
        {
            description: 'Smiling Face With Heart-Eyes',
            codes: ['heart_eyes'],
            snippets: [],
            default: 'heart_eyes',
            fileName: 'yard-smiley-10',
        },
        {
            description: 'Angry Face',
            codes: ['angry'],
            snippets: [],
            default: 'angry',
            fileName: 'yard-smiley-11',
        },
        {
            description: 'Confounded Face',
            codes: ['confounded'],
            snippets: [':$'],
            default: 'confounded',
            fileName: 'yard-smiley-12',
        },
        {
            description: 'Smiling Face With Open Mouth & Cold Sweat',
            codes: ['sweat_smile'],
            snippets: [],
            default: 'sweat_smile',
            fileName: 'yard-smiley-13',
        },
        {
            description: 'Face Blowing a Kiss',
            codes: ['kissing_heart'],
            snippets: [';*', ';-*'],
            default: 'kissing_heart',
            fileName: 'yard-smiley-14',
        },
        {
            description: 'Winking Face',
            codes: ['wink'],
            snippets: [';)', ';-)'],
            default: ';)',
            fileName: 'yard-smiley-15',
        },
        {
            description: 'Loudly Crying Face',
            codes: ['sob'],
            snippets: [],
            default: 'sob',
            fileName: 'yard-smiley-16',
        },
        {
            description: 'Smiling Face',
            codes: ['relaxed'],
            snippets: [],
            default: 'relaxed',
            fileName: 'yard-smiley-17',
        },
        {
            description: 'Worried Face',
            codes: ['worried'],
            snippets: [],
            default: 'worried',
            fileName: 'yard-smiley-18',
        },
        {
            description: 'Smiling Face With Sunglasses',
            codes: ['sunglasses', 'cool'],
            snippets: ['8)', '8-)'],
            default: 'sunglasses',
            fileName: 'yard-smiley-19',
        },
        {
            description: 'Persevering Face',
            codes: ['persevere'],
            snippets: [],
            default: 'persevere',
            fileName: 'yard-smiley-20',
        },
        {
            description: 'Crying Face',
            codes: ['cry'],
            snippets: [":'(", ":'‑("],
            default: 'cry',
            fileName: 'yard-smiley-21',
        },
        {
            description: 'Disappointed Face',
            codes: ['disappointed', 'anguished'],
            snippets: [':(', ':-(', ';(', ';-('],
            default: ':(',
            fileName: 'yard-smiley-22',
        },
        {
            description: 'Face Without Mouth',
            codes: ['no_mouth'],
            snippets: [';X', ':#', ':-X', ':-#'],
            default: 'no_mouth',
            fileName: 'yard-smiley-23',
        },
        {
            description: 'Expressionless Face',
            codes: ['expressionless'],
            snippets: [';|'],
            default: 'expressionless',
            fileName: 'yard-smiley-24',
        },
        {
            description: 'Face With Medical Mask',
            codes: ['mask'],
            snippets: [],
            default: 'mask',
            fileName: 'yard-smiley-25',
        },
        {
            description: 'Face With Open Mouth',
            codes: ['open_mouth'],
            snippets: [':‑o', ';o', ':-0'],
            default: 'open_mouth',
            fileName: 'yard-smiley-26',
        },
        {
            description: 'Kissing Face With Smiling Eyes',
            codes: ['kissing_smiling_eyes'],
            snippets: [':*', ':-*'],
            default: ':*',
            fileName: 'yard-smiley-27',
        },
        {
            description: 'Rolling on the Floor Laughing',
            codes: ['rofl'],
            snippets: [], // xD will replace YouTube urls...
            default: 'xD',
            fileName: 'yard-smiley-29',
        },
        {
            description: 'Smiling Face With Halo',
            codes: ['innocent'],
            snippets: ['O:‑)', 'O:)'],
            default: 'innocent',
            fileName: 'yard-smiley-30',
        },
    ])
    .constant('$moji.config', {
        extension: 'png',
        'http.path': 'img/smiles',
        isolation: ['(', ')'],
    })
    .factory('$moji.factory', [
        '$moji.config',
        '$moji.sizes',
        '$moji.mapping',
        function ($config, $sizes, $mapping) {
            var openIsolationSign = $config.isolation[0] ? $config.isolation[0] : '',
                closeIsolationSign = $config.isolation[1] ? $config.isolation[1] : '';

            function regExpQuote(string) {
                return (string + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }

            function getMojiPath(name, size) {
                return '/' + $config['http.path'] + '/' + name + $sizes[size] + '.' + $config.extension;
            }

            function getHtmlNode(mojiItem, size) {
                return (
                    '<img src="' +
                    getMojiPath(mojiItem.fileName, size) +
                    '" title="' +
                    mojiItem.description +
                    '" alt="' +
                    mojiItem.description +
                    '" class="moji-icon"/>'
                );
            }

            function parseChildNodes(childNodes) {
                var messages = [];

                if (childNodes && childNodes.length) {
                    childNodes.forEach(function (item) {
                        messages.push(item.textContent);

                        messages.concat(parseChildNodes(item.childNodes));
                    });
                }

                return messages;
            }

            /**
             * Check is doom parsing have errors.
             *
             * @param parsedDocument
             * @returns {boolean}
             */
            function isParseError(parsedDocument) {
                var parser = new DOMParser(),
                    errorParse = parser.parseFromString('<', 'text/xml'),
                    parserNS = errorParse.getElementsByTagName('parsererror')[0].namespaceURI;

                if (parserNS === 'http://www.w3.org/1999/xhtml') {
                    return parsedDocument.getElementsByTagName('parsererror').length > 0;
                }

                return parsedDocument.getElementsByTagNameNS(parserNS, 'parsererror').length > 0;
            }

            function getListTextFromMessage(message) {
                var domParser = new DOMParser();
                var domElement = domParser.parseFromString(message, 'text/xml');

                if (isParseError(domElement)) {
                    return parseChildNodes(domElement.documentElement.childNodes).concat([message]);
                }

                return parseChildNodes(domElement.documentElement.childNodes);
            }

            function parseMojiItems(mojiItem, type) {
                var flag = 'gi';

                return mojiItem[type].map(function (moji, index) {
                    if (type === 'codes') {
                        moji = openIsolationSign + moji + closeIsolationSign;
                        flag = 'g';
                    }

                    return new RegExp(regExpQuote(moji), flag);
                });
            }

            function prepareMojisBySize(size) {
                return $mapping.map(function (mojiItem, mojiIndex) {
                    var codes = parseMojiItems(mojiItem, 'codes');
                    var snippets = parseMojiItems(mojiItem, 'snippets');

                    return {
                        image: getHtmlNode(mojiItem, size),
                        quotes: codes.concat(snippets),
                    };
                });
            }

            function parseMessage(message, mojiesList) {
                if (message && typeof message === 'string') {
                    var listOfMessages = getListTextFromMessage(message);

                    mojiesList.forEach(function (moji, index) {
                        listOfMessages.forEach(function (partMessage, index) {
                            var replacedMessage = moji.quotes.reduce(function (item, quote) {
                                return item.replace(quote, moji.image);
                            }, partMessage);

                            message = message.replace(
                                partMessage,
                                moji.quotes.reduce(function (item, quote) {
                                    return item.replace(quote, moji.image);
                                }, partMessage)
                            );

                            listOfMessages[index] = replacedMessage;
                        });
                    });

                    return message;
                } else {
                    return message;
                }
            }

            function getMojiInfo(size) {
                var mojiInfo = [];

                $mapping.forEach(function (mojiItem, mojiIndex) {
                    mojiInfo.push({
                        name: mojiItem.description,
                        // codes   : mojiItem.codes.map(function(code) {
                        //   return openIsolationSign + code + closeIsolationSign;
                        // }),
                        snippets: mojiItem.snippets
                            .concat(
                                mojiItem.codes.map(function (code) {
                                    return openIsolationSign + code + closeIsolationSign;
                                })
                            )
                            .join(', '),
                        image: getHtmlNode(mojiItem, size),
                    });
                });

                return mojiInfo;
            }

            return {
                getMojiPath: getMojiPath,
                getHtmlNode: getHtmlNode,
                regExpQuote: regExpQuote,
                parseMessage: parseMessage,
                getMojiInfo: getMojiInfo,
                prepareMojisBySize: prepareMojisBySize,
                getListTextFromMessage: getListTextFromMessage,
            };
        },
    ])
    .filter('moji', [
        '$moji.factory',
        '$sce',
        '$rootScope',
        function ($factory, $sce, $rootScope) {
            return function (message, size) {
                if (!$rootScope.mojiPreparedData) {
                    $rootScope.mojiPreparedData = [];
                }

                if (!$rootScope.mojiPreparedData[size]) {
                    $rootScope.mojiPreparedData[size] = $factory.prepareMojisBySize(size);
                }

                var messageContent = typeof message === 'object' ? $sce.valueOf(message) : message;
                var parsedMessage = $factory.parseMessage(messageContent, $rootScope.mojiPreparedData[size]);

                return $sce.trustAsHtml(parsedMessage);
            };
        },
    ])
    .controller('moji.controller', [
        '$scope',
        '$moji.factory',
        function ($scope, $factory) {
            $scope.mojiInfo = $factory.getMojiInfo('hdpi');
        },
    ])
    .directive('mojiProvider', [
        '$moji.mapping',
        '$moji.factory',
        '$sce',
        'contenteditableRegistry',
        '$document',
        function ($mapping, $factory, $sce, contenteditableRegistry, $document) {
            return {
                link: function (scope, element, attributes) {
                    function placeCaretAtEnd(el) {
                        el.focus();
                        if (typeof window.getSelection != 'undefined' && typeof document.createRange != 'undefined') {
                            var range = document.createRange();
                            range.selectNodeContents(el);
                            range.collapse(false);
                            var sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        } else if (typeof document.body.createTextRange != 'undefined') {
                            var textRange = document.body.createTextRange();
                            textRange.moveToElementText(el);
                            textRange.collapse(false);
                            textRange.select();
                        }
                    }

                    scope.mojiData = $mapping;
                    scope.mojiOpened = false;

                    scope.insertItem = function (item, size) {
                        var contentediable = contenteditableRegistry.element.get(attributes.mojiProvider);

                        contenteditableRegistry.focus(attributes.mojiProvider);

                        insertAtCaret(contentediable[0], '(' + item.codes[0] + ')');

                        // document.execCommand('insertHTML', false, '(' + item.codes[0] + ')');

                        // console.log(contentediable[0].dispatchEvent);

                        if (contentediable[0].dispatchEvent) {
                            contentediable[0].dispatchEvent(new CustomEvent('change'));
                        }
                    };

                    scope.renderItem = function (item, size) {
                        return $sce.trustAsHtml($factory.getHtmlNode(item, size));
                    };

                    scope.getItemPath = function (item, size) {
                        return $factory.getMojiPath(item, size);
                    };
                },
            };
        },
    ]);
